import {useTranslation} from '@aboutyou/i18n';
import {TrackContentPageView} from '@aboutyou/tracking';
import {FullWidthButton} from '@aboutyou/ui-components';
import React from 'react';
import styled from 'styled-components';
import {NewsletterLandingPage} from './NewsletterLandingPage';

export const UnsubscribeConfirmationLandingPage = () => {
  const {t} = useTranslation();
  return (
    <NewsletterLandingPage title={t("We're sad to see you go.")}>
      <TrackContentPageView pageTitle="unsubscribeConfirmationLandingPage" />
      <SublineContainer>
        {t(
          'You have been unsubscribed from this newsletter as per your request.',
        )}
      </SublineContainer>
      <TextContainer>
        {t(
          "Don't want to miss out on exclusive offers, promotions, and outfit suggestions? Just subscribe to our newsletter again at any time.",
        )}
      </TextContainer>
      <StyledButton
        disableShadow={true}
        type={'primary'}
        withBorder={false}
        href={'/'}
      >
        {t('Continue shopping')}
      </StyledButton>
    </NewsletterLandingPage>
  );
};

const StyledButton = styled(FullWidthButton)`
  display: block;
  border: none;
  span {
    display: block;
  }
`;

const SublineContainer = styled.div`
  margin-bottom: 20px;
  font-weight: 700;
`;

const TextContainer = styled.div`
  font-weight: 400;
  margin-bottom: 20px;
`;
